import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_2 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_modal_create_api_key_scroll",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-max-height": "auto",
  "data-kt-scroll-dependencies": "#kt_modal_create_api_key_header",
  "data-kt-scroll-wrappers": "#kt_modal_create_api_key_scroll",
  "data-kt-scroll-offset": "300px"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "mb-5 fv-row" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "modal-footer flex-center" }
const _hoisted_28 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_create_api_key_submit",
  class: "btn btn-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Form, {
      id: "kt_modal_create_api_key_form",
      class: "form",
      onSubmit: _ctx.submit,
      "validation-schema": _ctx.validationSchema
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "Sigfox Id", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid border border-primary",
                    rows: "3",
                    name: "variant_id",
                    placeholder: "Sigfox Id",
                    modelValue: _ctx.sigfoxData.variant_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sigfoxData.variant_id) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_ErrorMessage, { name: "variant_id" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "PAC ID", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid border border-primary",
                    rows: "3",
                    name: "pac_id",
                    placeholder: "Pack id",
                    modelValue: _ctx.sigfoxData.pac_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sigfoxData.pac_id) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "pac_id" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-2" }, "Product Count", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "bg-light rounded-2 form-control form-control-solid border border-primary",
                    placeholder: "Product Count",
                    name: "product_count",
                    modelValue: _ctx.sigfoxData.product_count,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sigfoxData.product_count) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "Device Serial ID", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid border border-primary",
                    rows: "3",
                    name: "serial_number",
                    placeholder: "Serial Number",
                    modelValue: _ctx.sigfoxData.serial_number,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sigfoxData.serial_number) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "serial_number" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "fs-5 fw-bold mb-2 ms-2" }, "Product Id", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid border border-primary",
                    rows: "3",
                    name: "product_id",
                    placeholder: "Product Id",
                    modelValue: _ctx.sigfoxData.product_id,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sigfoxData.product_id) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_ErrorMessage, { name: "product_id" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "required fs-5 fw-bold mb-2 ms-2" }, "Device UID", -1)),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid border border-primary",
                    rows: "3",
                    name: "unique_random_number",
                    placeholder: "Enter Device UID",
                    modelValue: _ctx.sigfoxData.unique_random_number,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.sigfoxData.unique_random_number) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_component_ErrorMessage, { name: "unique_random_number" })
                    ])
                  ])
                ])
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-md-4" }, null, -1)),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-md-4" }, null, -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", _hoisted_28, _cache[14] || (_cache[14] = [
            _createElementVNode("span", { class: "indicator-label" }, " Submit ", -1),
            _createElementVNode("span", { class: "indicator-progress" }, [
              _createTextVNode(" Please wait... "),
              _createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
            ], -1)
          ]), 512)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}